// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__1qnD5","box":"WorkspacesBox_box__MYOcK","node":"WorkspacesBox_node__39SIZ"};